function extractFilenameFromDisposition(disposition) {
  if (!disposition || typeof disposition !== 'string') {
    return null;
  }
  var match = disposition.match(/filename\\*?=(?:UTF-8''|\"?)([^\";]+)\"?/i);
  if (!match || !match[1]) {
    return null;
  }
  try {
    return decodeURIComponent(match[1]);
  } catch (err) {
    return match[1];
  }
}

function buildErrorMessage(res, text) {
  if (text) {
    try {
      var parsed = JSON.parse(text);
      if (parsed && (parsed.error || parsed.message)) {
        return parsed.error || parsed.message;
      }
    } catch (err) {
      // Fall back to plain text below.
    }
    return text;
  }
  if (res && res.status) {
    return 'Download failed (' + res.status + ')';
  }
  return 'Download failed';
}

function downloadFile(url, options) {
  var filename = options && options.filename;
  return fetch(url, { credentials: 'same-origin' })
    .then(function (res) {
      if (!res.ok) {
        return res.text().then(function (text) {
          var err = new Error(buildErrorMessage(res, text));
          err.status = res.status;
          throw err;
        });
      }
      if (!filename) {
        filename = extractFilenameFromDisposition(res.headers.get('content-disposition'));
      }
      return res.blob().then(function (blob) {
        var link = document.createElement('a');
        var objectUrl = window.URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = filename || 'download';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(objectUrl);
          if (link.parentNode) {
            link.parentNode.removeChild(link);
          }
        }, 0);
      });
    });
}

module.exports = downloadFile;
